import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

const DragAndDropItem = ({ data, itemStyle }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: data.id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    ...itemStyle,
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      {data.content}
    </div>
  );
};

export default DragAndDropItem;
